<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">To my kids, still coping with me working all hours. You rock, guys.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?075da22b